import ThesaurusField from './fields/ThesaurusField.js';
import * as TypeThesaurus from './TypeThesaurus.js';
import TextField from './fields/TextField.js';
import { CustomSelect } from './fields/CustomSelect.js';
import { useState } from 'react';
import PropTypes from 'prop-types';

const FormBiblio = ({ listLocalisationBiblio }) => {
  const urlParams = new URL(document.location).searchParams;

  const [types, setTypes] = useState({
    valeur: urlParams.get('type') ?? '',
    label: urlParams.get('typeLabel'),
  });
  const [titre, setTitre] = useState({ valeur: urlParams.get('titre') ?? '' });
  const [auteur, setAuteur] = useState({
    valeur: urlParams.get('auteur') ?? '',
  });
  const [datePublication, setDatePublication] = useState({
    valeur: urlParams.get('datePublication') ?? '',
  });
  const [publicationRegion, setPublicationRegion] = useState({
    valeur: urlParams.get('publicationRegion') === 'true',
  });
  const [editeursNom, setEditeursNom] = useState({
    valeur: urlParams.get('editeursNom') ?? '',
  });
  const [editeursLieu, setEditeursLieu] = useState({
    valeur: urlParams.get('editeursLieu') ?? '',
  });
  const [mentionEdition, setMentionEdition] = useState({
    valeur: urlParams.get('mentionEdition') ?? '',
  });
  const [collation, setCollation] = useState({
    valeur: urlParams.get('collation') ?? '',
  });
  const [collection, setCollection] = useState({
    valeur: urlParams.get('collection') ?? '',
  });
  const [numCollection, setNumCollection] = useState({
    valeur: urlParams.get('numCollection') ?? '',
  });
  const [isbn, setIsbn] = useState({ valeur: urlParams.get('isbn') ?? '' });
  const [issn, setIssn] = useState({ valeur: urlParams.get('issn') ?? '' });
  const [langues, setLangues] = useState({
    valeur: urlParams.get('langues') ?? '',
    label: urlParams.get('langueLabel'),
  });
  const [numExemplaire, setNumExemplaire] = useState({
    valeur: urlParams.get('numExemplaire') ?? '',
  });
  const [numPeriodique, setNumPeriodique] = useState({
    valeur: urlParams.get('numPeriodique') ?? '',
  });
  const [cote, setCote] = useState({ valeur: urlParams.get('cote') ?? '' });
  const [note, setNote] = useState({ valeur: urlParams.get('note') ?? '' });
  const [resume, setResume] = useState({
    valeur: urlParams.get('resume') ?? '',
  });
  const [tag, setTag] = useState({ valeur: urlParams.get('tag') ?? '' });

  const definitionTypesBiblio = {
    typeThesaurus: [TypeThesaurus.BIBLIO_TYPE],
  };
  const definitionLanguesBiblio = {
    typeThesaurus: [TypeThesaurus.BIBLIO_LANGUE],
  };

  const localisationOptions = Object.entries(listLocalisationBiblio)
    .map(([value, label]) => ({ value, label }))
    .toSorted((option1, option2) =>
      option1.label.localeCompare(option2.label, 'fr'),
    );

  const [localisation, setLocalisation] = useState(
    urlParams.get('localisation')
      ? localisationOptions.find(
          (localisation) =>
            localisation.value === urlParams.get('localisation'),
        )
      : { valeur: '', label: '' },
  );

  return (
    <form
      className="expert-form"
      method="GET"
      action={window.routes.rechercheExperteBiblio}
    >
      <h1 className="expert-form-title">Recherche avancée</h1>
      <div className="criteres-biblio">
        <div className="critere">
          <label className="critere-label"> Type </label>
          <div className="critere-field">
            <ThesaurusField
              fieldDefinition={definitionTypesBiblio}
              defaultValue={types}
              name="type"
              onChange={setTypes}
            />
          </div>
        </div>

        <div className="critere">
          <label className="critere-label"> Titre </label>
          <div className="critere-field">
            <TextField name="titre" defaultValue={titre} onChange={setTitre} />
          </div>
        </div>

        <div className="critere">
          <label className="critere-label">Auteur(s) </label>
          <div className="critere-field">
            <TextField
              name="auteur"
              defaultValue={auteur}
              onChange={setAuteur}
            />
          </div>
        </div>

        <div className="critere">
          <label className="critere-label">Date de publication</label>
          <div className="critere-field">
            <TextField
              type="number"
              name="datePublication"
              defaultValue={datePublication}
              onChange={setDatePublication}
            />
          </div>
        </div>

        <div className="critere critere-inline">
          <input
            type="checkbox"
            name="publicationRegion"
            id="publicationRegion"
            checked={publicationRegion.valeur}
            onChange={(e) => {
              setPublicationRegion(e.target.checked);
            }}
            value="true"
          />
          <label htmlFor="publicationRegion" className="critere-label">
            Publications régionales
          </label>
        </div>

        <div className="critere">
          <label className="critere-label">Editeur(s)</label>
          <div className="critere-field">
            <TextField
              name="editeursNom"
              defaultValue={editeursNom}
              onChange={setEditeursNom}
            />
          </div>
        </div>

        <div className="critere">
          <label className="critere-label">Lieu d&apos;Edition</label>
          <div className="critere-field">
            <TextField
              name="editeursLieu"
              defaultValue={editeursLieu}
              onChange={setEditeursLieu}
            />
          </div>
        </div>

        <div className="critere">
          <label className="critere-label">Mention d&apos;Edition</label>
          <div className="critere-field">
            <TextField
              name="mentionEdition"
              defaultValue={mentionEdition}
              onChange={setMentionEdition}
            />
          </div>
        </div>

        <div className="critere">
          <label className="critere-label">Collation</label>
          <div className="critere-field">
            <TextField
              name="collation"
              defaultValue={collation}
              onChange={setCollation}
            />
          </div>
        </div>

        <div className="critere">
          <label className="critere-label">Collection</label>
          <div className="critere-field">
            <TextField
              name="collection"
              defaultValue={collection}
              onChange={setCollection}
            />
          </div>
        </div>

        <div className="critere">
          <label className="critere-label"> Numéro de la collection</label>
          <div className="critere-field">
            <TextField
              name="numCollection"
              defaultValue={numCollection}
              onChange={setNumCollection}
            />
          </div>
        </div>

        <div className="critere">
          <label className="critere-label"> ISBN</label>
          <div className="critere-field">
            <TextField name="isbn" defaultValue={isbn} onChange={setIsbn} />
          </div>
        </div>

        <div className="critere">
          <label className="critere-label"> ISSN</label>
          <div className="critere-field">
            <TextField name="issn" defaultValue={issn} onChange={setIssn} />
          </div>
        </div>

        <div className="critere">
          <label className="critere-label"> Langue </label>
          <div className="critere-field">
            <ThesaurusField
              fieldDefinition={definitionLanguesBiblio}
              defaultValue={langues}
              name="langues"
              onChange={setLangues}
            />
          </div>
        </div>

        <div className="critere">
          <label className="critere-label"> Localisation </label>
          <div className="critere-field">
            <CustomSelect
              className="critere-input"
              value={localisation}
              name="localisation"
              onChange={setLocalisation}
              options={localisationOptions}
            />
          </div>
        </div>

        <div className="critere">
          <label className="critere-label"> Numéro d&apos;exemplaire</label>
          <div className="critere-field">
            <TextField
              name="numExemplaire"
              defaultValue={numExemplaire}
              onChange={setNumExemplaire}
            />
          </div>
        </div>

        <div className="critere">
          <label className="critere-label"> Numéro du périodique</label>
          <div className="critere-field">
            <TextField
              name="numPeriodique"
              defaultValue={numPeriodique}
              onChange={setNumPeriodique}
            />
          </div>
        </div>

        <div className="critere">
          <label className="critere-label"> Cote </label>
          <div className="critere-field">
            <TextField name="cote" defaultValue={cote} onChange={setCote} />
          </div>
        </div>

        <div className="critere">
          <label className="critere-label"> Note </label>
          <div className="critere-field">
            <TextField name="note" defaultValue={note} onChange={setNote} />
          </div>
        </div>

        <div className="critere">
          <label className="critere-label"> Résumé </label>
          <div className="critere-field">
            <TextField
              name="resume"
              defaultValue={resume}
              onChange={setResume}
            />
          </div>
        </div>

        <div className="critere">
          <label className="critere-label">Mot-clé</label>
          <div className="critere-field">
            <TextField name="tag" defaultValue={tag} onChange={setTag} />
          </div>
        </div>
      </div>

      <div className="expert-form-footer-actions">
        <button type="submit" className="expert-form-launch-search-btn">
          Lancer la recherche
        </button>
      </div>
    </form>
  );
};

FormBiblio.propTypes = {
  listLocalisationBiblio: PropTypes.object.isRequired,
};
export default FormBiblio;
